module.exports = __webpack_public_path__ + "media/mx_pcb_assembly/map-a7af78a2.png";